import { Project } from "@core/domain/models/project.model";
import { Role } from "@core/domain/types/role.type";
import { DisplayProjectDto } from "@evidence/sdk";

export function toProject(data: DisplayProjectDto): Project {
  return new Project({
    id: data.id,
    name: data.name,
    contactForComplaintEmail: data.contactForComplaintEmail,
    cslStyle: data.cslStyle,
    isFavorite: data.isFavorite,
    reviewSeries:
      data.reviewSeries?.map((rs) => ({
        id: rs.id,
        name: rs.name,
        order: rs.order,
        projectId: rs.projectId,
        reviews:
          rs.reviews?.map((r) => ({
            id: r.id,
            createdAt: new Date(r.createdAt),
            isLocked: r.isLocked,
            name: r.name,
          })) ?? [],
      })) ?? [],
    users: data.users?.map((u) => ({
      email: u.email,
      firstName: u.firstName,
      id: u.id,
      lastName: u.lastName,
      isDisabled: u.isDisabled,
      role: u.role as Role,
    })),
    teamId: data.teamId,
  });
}
